// extracted by mini-css-extract-plugin
module.exports = {"maindiv":"PreviousOrders_maindiv__1WG2p","layoverloading":"PreviousOrders_layoverloading__1Vo1x"};